import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose as reduxCompose
} from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import appReducer from "../reducers";

// Creates a reducer with the current history object from the state and a persists it
// to localStorage, which allows transferring the state between page reloads.
//
const reducer = persistReducer(
  {
    storage,
    key: "root",
    whitelist: ["forms", "alert", "privacy"]
  },
  appReducer
);

const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || reduxCompose;

// This creates a redux store and applies the connected-react-router's routerMiddleware
// with the current history stored in the component's state.
//
const store = createStore(reducer, compose(applyMiddleware(thunk)));

const persistor = persistStore(store);

export { store, persistor };
